module.exports = __webpack_public_path__ + "static/media/cand_mamilo_claro.8b2cac51.png";